import { catchError, map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';

import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { RentalObjectCategory } from './../../model/const/enums';
import { Observable } from 'rxjs';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { RentApplication } from '../../model/rent-application';

@Injectable()
export class RentApplicationService extends DataService<RentApplication> {
  private readonly _default_FilterFields: string[] = ['rentalObjectCat', 'name', 'email', 'contactIdentification'];

  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, RentApplication, progressBar, 'rentapplication');
  }

  export(ids: string[]): Observable<File> {
    return super.exportDataItems(ids, 'Intresselista.xlsx');
  }

  getFilterDefinition(): Observable<{
    name: string;
    email: string;
    civicOrOrganizationNo: string;
    rentalObjectCat: number;
    selectedFields: string[];
    defaultFields: string[];
  }> {
    return this.client.get<any>(`${this.endpoint}/filter`).pipe(
      map(res => {
        return {
          name: res.name ? res.name : '',
          email: res.email ? res.email : '',
          civicOrOrganizationNo: res.civicOrOrganizationNo ? res.civicOrOrganizationNo : '',
          rentalObjectCat: Number.isInteger(res.rentalObjectCat) ? res.rentalObjectCat : 9,
          selectedFields: Array.isArray(res.selectedFields) ? res.selectedFields : this._default_FilterFields,
          defaultFields: this._default_FilterFields,
        };
      }),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }
}
